import { PHONE, locationSchema } from "../structured-data-core";

export function getMilwaukeeStructuredData() {
  const url = "https://restorehair.com/locations/wisconsin/milwaukee/";
  const description =
    "Find out about your hair transplant options in Milwaukee with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Milwaukee", "250 East Wisconsin Avenue, Suite 1800", "Milwaukee", "WI", PHONE, url, description),
  ];
}
